<template>
    <div>
        <v-progress-circular indeterminate v-if="preparing"></v-progress-circular>
        <v-data-table
          :disable-pagination="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="offerItems"
          class="elevation-1"
          v-else
        >
          <template v-slot:top>
            <v-toolbar color="white" flat>
              <v-row class="p-2 mt-2">
                <v-col cols="4">
                  <v-toolbar-title class="title">
                    {{$t("steps.offer.label")}}
                    </v-toolbar-title>
                    <p class="text-left">{{ $t('settings.currency.sinlge') + offerCurrency.code + ' '+ $t('settings.currency.rate') + offerRate}}</p>
                </v-col>


                <v-col cols="4">
                    <v-row class="mt-0">
                        <v-col>
                            <CurrencySelect v-model="currency">

                            </CurrencySelect>
                        </v-col>
                        <v-btn
                            color="red lighten-2"
                            dark
                            class="ml-2"
                            @click="recalculate"
                            :disabled="!currency"
                            >
                            {{$t('settings.currency.recalculate')}}
                        </v-btn>
                    </v-row>

                </v-col>

                <v-col cols="2">
                    <v-dialog
                    max-width="800px"
                    @keydown.esc="close"
                    @keydown.enter.prevent="saveGlobalDiscount"
                    v-model="dialogGlobalDiscount"
                    >
                        <template v-slot:activator="{on}">
                            <v-edit-dialog
                                @save="saveGlobalDiscount"
                                @cancel="dialogcancel"
                                @open="dialogopen()"
                                @close="dialogclose">
                                <v-btn
                                    color="red lighten-2"
                                    dark
                                    >
                                    Rabat
                                </v-btn>
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="globalDiscount"
                                        label="Edit"
                                        single-line
                                        counter
                                        ></v-text-field>
                                </template>
                        </v-edit-dialog>
                        </template>



                    </v-dialog>
                </v-col>
                <v-col cols="1">
                  <v-btn @click="addItem" class="mb-2" color="blue" dark
                    >{{ $t("steps.offer.newItem") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-toolbar>

            <v-dialog
              max-width="800px"
              @keydown.esc="close"
              @keydown.enter.prevent="save"
              v-model="dialog"
            >
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-form lazy-validation @submit.prevent v-model="valid">
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="4" sm="6">
                          <translatable-text-field
                            :label="$t('steps.offer.product')"
                            v-model="editedItem.product"
                          >
                          </translatable-text-field>
                        </v-col>
                      </v-row>
                      <v-subheader>{{
                        $t("steps.offer.prices.unit.generally")
                      }}</v-subheader>
                      <v-row>
                        <v-col cols="12" md="4" sm="6">
                          <v-text-field
                            :label="$t('steps.offer.prices.unit.net')"
                            type="number"
                            v-model="editedItem.price"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                          <v-select
                            :items="taxes"
                            :label="$t('steps.offer.tax')"
                            item-text="label"
                            item-value="value"
                            v-model="editedItem.tax"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <div>{{ $t("steps.offer.prices.unit.gross") }}</div>
                          <div style="color: #000; font-size: 18px">
                            {{ unitPriceGross | priceDecimal }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-subheader>{{ $t("steps.offer.amount") }}</v-subheader>
                      <v-row>
                        <v-col cols="12" md="4" sm="6">
                          <v-select
                            :disabled="editedItem.obligatory"
                            :items="units"
                            :label="$t('steps.offer.unit')"
                            item-text="label"
                            return-object
                            v-model="editedItem.unit"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-text-field
                            :disabled="blockAmount || editedItem.obligatory"
                            :label="$t('steps.offer.amount')"
                            type="number"
                            v-model="editedItem.amount"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-subheader>{{ $t("steps.offer.discount") }}</v-subheader>
                      <v-row>
                        <v-col cols="12" md="4" sm="6">
                          <v-text-field
                            :label="$t('steps.offer.discount') + ' [%]'"
                            type="number"
                            :rules="discountRules"
                            v-model="editedItem.discount"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-subheader>{{ $t("steps.offer.summary") }}</v-subheader>
                      <v-row>
                        <div class="product-summary-row">
                          {{ $t("steps.offer.prices.total.net") }}:
                          <span class="value">{{
                            (editedItem.price * editedItem.amount)
                              | priceDecimal
                              | trailingZeros
                          }}</span>
                        </div>
                        <div class="product-summary-row">
                          {{ $t("steps.offer.discount") }}:
                          <span class="value">{{
                            discount(editedItem) | priceDecimal | trailingZeros
                          }}</span>
                        </div>
                        <div class="product-summary-row">
                          {{ $t("steps.offer.prices.total.netwd") }}:
                          <span class="value">{{
                            total(editedItem) | priceDecimal | trailingZeros
                          }}</span>
                        </div>
                        <div class="product-summary-row">
                          {{ $t("steps.offer.prices.total.grosswd") }}:
                          <span class="value">{{
                            totalGross(editedItem) | priceDecimal | trailingZeros
                          }}</span>
                        </div>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="close" color="blue darken-1" text>{{
                    $t("base.cancel")
                  }}</v-btn>
                  <v-btn
                    @click="save"
                    :disabled="!valid"
                    color="blue darken-1"
                    text
                    >{{ $t("base.save") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!--  -->

          <template v-slot:item.price="{ item }">
            <v-edit-dialog
              :return-value.sync="item.price"
              @save="save"
              @cancel="dialogcancel"
              @open="dialogopen(item)"
              @close="dialogclose"
            >
              {{ item.price }}
              <template v-slot:input>
                <v-text-field
                  v-model="item.price"
                  @input="updateParam($event, 'price')"
                  label="Edit"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.tax="{ item }">
            <v-edit-dialog
              :return-value.sync="item.tax"
              @save="save"
              @cancel="dialogcancel"
              @open="dialogopen(item)"
              @close="dialogclose"
            >
              {{ item.tax }}
              <template v-slot:input>
                <v-select
                  :items="taxes"
                  :label="$t('steps.offer.tax')"
                  item-text="label"
                  item-value="value"
                  v-model="item.tax"
                  @change="updateParam($event, 'tax')"
                >
                </v-select>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.unit="{ item }">
            <v-edit-dialog
              :return-value.sync="item.unit"
              @save="save"
              @cancel="dialogcancel"
              @open="dialogopen(item)"
              @close="dialogclose"
            >
              {{ item.unit.shortcut }}
              <template v-slot:input>
                <v-select
                  :disabled="editedItem.obligatory"
                  :items="units"
                  :label="$t('steps.offer.unit')"
                  item-text="label"
                  v-model="item.unit"
                  return-object
                  @change="updateParam($event, 'unit')"
                >
                </v-select>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:item.amount="{ item }">
            <v-edit-dialog
              :return-value.sync="item.amount"
              @save="save"
              @cancel="dialogcancel"
              @open="dialogopen(item)"
              @close="dialogclose"
            >
              {{ item.amount }}
              <template v-slot:input>
                <v-text-field
                  v-model="item.amount"
                  @input="updateParam($event, 'amount')"
                  label="Edit"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.discount="{ item }">
            <v-edit-dialog
              :return-value.sync="item.discount"
              @save="save"
              @cancel="dialogcancel"
              @open="dialogopen(item)"
              @close="dialogclose"
            >
              {{ item.discount }}
              <template v-slot:input>
                <v-text-field
                  v-model="item.discount"
                  @input="updateParam($event, 'discount')"
                  label="Edit"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.product="{ item }">
            {{ item.product[$locale] }}
          </template>

          <!--  -->

          <template v-slot:item.action="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="deleteItem(item)"
                  color="orange"
                  fab
                  small
                  v-if="!item.obligatory"
                  v-on="on"
                >
                  <v-icon color="white"> mdi-delete </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("base.remove") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.summary="{ item }">
            {{ (item.price * item.amount) | priceDecimal | trailingZeros }}
          </template>
          <template v-slot:item.total="{ item }">
            {{
              (item.price * item.amount * (1 - item.discount / 100))
                | priceDecimal
                | trailingZeros
            }}
          </template>
          <template v-slot:body.append>
            <tr class="font-weight-bold">
              <td colspan="5">{{ $t("base.total") }}</td>
              <td colspan="3">{{ sumPrice | priceDecimal | trailingZeros }}</td>
              <td colspan="2">{{ sumTotal | priceDecimal | trailingZeros }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-snackbar v-model="snack" :timeout="1500" :color="snackColor">
            {{ snackText }}

            <template v-slot:action="{ attrs }">
                <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import TranslatableTextField from "@/components/common/TranslatableTextField";
import units from "@/helpers/units";
import discountTypes from "@/helpers/discountTypes";
import itemType from "@/helpers/ItemType";
import CurrencySelect from "../common/CurrencySelect.vue";
export default {
    name: "OfferCalculation",
    components: { TranslatableTextField, CurrencySelect},
    computed: {
    taxes() {
      return [
        {
          label: "23%",
          value: 23,
        },
        {
          label: "8%",
          value: 8,
        },
        {
          label: "0%",
          value: 0,
        },
      ];
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("steps.offer.newItem")
        : this.$t("steps.offer.edition", {
            item: this.editedItem.product[this.$locale],
          });
    },
    offerItems() {
      return this.$store.state.configurator.offer.items;
    },
    currentUnit() {
      return this.editedItem.unit;
    },
    currentDiscount() {
      return this.editedItem.discount;
    },
    units() {
      return units.filter((unit) => unit.id !== 4);
    },
    unitPriceGross() {
      return (this.editedItem.price * (this.editedItem.tax + 100)) / 100;
    },
    discountTypes() {
      return discountTypes;
    },
    headers() {
      return [
        {
          text: this.$t("steps.offer.product"),
          value: "product",
        },
        {
          text: this.$t("steps.offer.prices.unit.net"),
          value: "price",
        },
        {
          text: this.$t("steps.offer.tax"),
          value: "tax",
        },
        {
          text: this.$t("steps.offer.unit"),
          value: "unit",
        },
        {
          text: this.$t("steps.offer.amount"),
          value: "amount",
        },
        {
          text: this.$t("steps.offer.prices.total.net"),
          value: "summary",
        },
        {
          text: this.$t("steps.offer.discountType"),
          value: "discountType.label",
        },
        {
          text: this.$t("steps.offer.discount"),
          value: "discount",
        },
        {
          text: this.$t("steps.offer.prices.total.netwd"),
          value: "total",
        },
        {
          text: this.$t("base.actions"),
          value: "action",
          sortable: false,
          width: 140,
        },
      ];
    },
    sumPrice() {
      return this.$store.getters.summaryOfferItemsPrice;
    },
    sumTotal() {
      return this.$store.getters.summaryOfferItemsTotal;
    },
    complementary() {
      return this.$store.getters.items(itemType.complementary.id);
    },
    surfaces() {
      return this.$store.state.configurator.surfaces;
    },
    surfacesWithIndex() {
      return this.surfaces.map((surfaces, index) => ({
        ...surfaces,
        index: index + 1,
      }));
    },
    surfacesHeader() {
      return [
        {
          text: this.$t("steps.offer.surfaces.headers.number"),
          value: "index",
        },
        {
          text: this.$t("steps.offer.surfaces.headers.surface"),
          value: "area",
        },
      ];
    },
    surfaceSumary() {
      return this.$store.getters.summarySurfaceArea;
    },
    offerCurrency(){
        return this.$store.getters.offerCurrency;
    },
    offerRate(){
        return this.$store.getters.offerRate;
    }
  },
  data() {
    return {
      preparing: false,
      blockAmount: false,
      dialog: false,
      valid: true,
      editedIndex: -1,
      editedItem: { unit: null, item_id: null},
      addedItem: null,
      discountRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 100) ||
          this.$t("validation.discount"),
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      globalDiscount: 0,
      dialogGlobalDiscount: false,
      currency: null
    };
  },
  methods: {
    refreshEditedItem() {
      this.editedIndex = -1;
      this.editedItem = {
        product: { pl: "", en: "" },
        price: 0,
        tax: 23,
        unit: this.units[0],
        amount: 1,
        discountType: this.discountTypes[0],
        discount: 0,
        total: 0,
        obligatory: false,
      };
    },
    editItem(item) {
      this.editedIndex = this.offerItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    addItem() {
      this.editedIndex = -1;
      this.refreshEditedItem();
      this.dialog = true;
    },
    deleteItem(item) {
      confirm(
        this.$t("steps.offer.removeItem", { product: item.product.pl })
      ) && this.$store.commit("removeOfferItem", item);
    },
    save() {
      this.editedItem.total = this.total(this.editedItem);
      this.editedItem.item_id = this.editedItem.item_id ? this.editedItem.item_id : this.editedItem.id

      if (this.editedIndex > -1) {
        this.$store.commit("editOfferItem", {
          index: this.editedIndex,
          data: this.editedItem,
        });
      } else {
        this.$store.commit("addOfferItem", {
          data: this.editedItem,
        });
      }
      this.dialogsave();
      this.close();
      this.refreshEditedItem();
    },
    saveGlobalDiscount() {
    let type =this.discountTypes[1];
     if(this.globalDiscount == 0){
        type = this.discountTypes[0];
     }

    this.$store.commit("applayGlobalDiscount", {
        data: this.globalDiscount,
        type: type
    })

      this.dialogsave();
      this.close();
    },
    close() {
      this.dialog = false;
    },
    discount(product) {
      if (product.discountType) {
        return product.discountType.calculation(
          product.price * product.amount,
          product.discount
        );
      }
      return product.discount;
    },
    total(product) {
      return product.price * product.amount - this.discount(product);
    },
    totalGross(product) {
      return (this.total(product) * (100 + product.tax)) / 100;
    },
    ////////////
    dialogsave() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Dane zapisane";
    },
    dialogcancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Anulowano";
    },
    dialogopen(item) {
      this.editedIndex = this.offerItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Wpisz dane";
    },
    dialogclose() {},
    updateParam(event, param) {
      if (this.editedItem) this.editedItem[param] = event;
    },
    recalculate(){
        this.$store.commit('recalculateByCurrency', this.currency)
    }

    ////////////
  },
  mounted() {
    this.refreshEditedItem();
  },
  watch: {
    currentUnit(newUnit) {
      if (newUnit && !newUnit.countable) {
        this.editedItem.amount = 1;
        this.blockAmount = true;
      } else {
        this.blockAmount = false;
      }
    },
    currentDiscount(discount) {
      if (discount > 0) {
        this.editedItem.discountType = this.discountTypes[1];
      } else {
        this.editedItem.discountType = this.discountTypes[0];
        discount = 0;
      }
    }


  },
}
</script>
<style scoped>
.product-summary-row {
  color: #464646;
  padding: 10px 16px;
  line-height: 20px;
  font-size: 18px;
  font-weight: lighter;
  display: block;
  width: 100%;
}

.product-summary-row .value {
  font-weight: initial;
}
.title {
  text-align: left;
}
</style>
